import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import deleteWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import Mail from "@insite/mobius/Icons/Mail";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ContactAccountMangerButton from "@tIronValleySupply/Components/ContactAccountMangerButton";
import addNotifiyMeHandler from "@tIronValleySupply/Handlers/AddNotifyMeHandler";
import notifiyMeHandler from "@tIronValleySupply/Handlers/NotifyMeHandler";
import stockingList from "@tIronValleySupply/Handlers/StockListingHandler";
import InToWishList from "@tIronValleySupply/Icons/InToWishList";
import OutOfStock from "@tIronValleySupply/Icons/OutOfWIshList";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@tIronValleySupply/Overrides/Components/ProductAddToListLink";
import CustomApplicationState from "@tIronValleySupply/Store/Data/CustomApplicationState/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    const stockingListID = state.IronValleyData.StockListingStore.wishlistId;
    const wishListData = getWishListState(state, stockingListID).value;
    const session = getSession(state);
    const billToNumber = getBillToState(state, session.billToId).value?.customerNumber;
    const productNumbers = state.IronValleyData.NotifiyMeStore.productNumbers;
    return {
        variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
        wishListData,
        stockingListID,
        session,
        billToNumber,
        productNumbers,
    };
};

const mapDispatchToProps = {
    stockingList,
    loadWishList,
    deleteWishListLine,
    notifiyMeHandler,
    addNotifiyMeHandler,
};

type OwnProps = WidgetProps &
    HasProduct &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;
export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
    stockingBtn?: LinkPresentationProps;
    EyeIcon?: IconPresentationProps;
    removeLink?: LinkPresentationProps;
    notifyBtn?: LinkPresentationProps;
    notifyBtnInStock?: LinkPresentationProps;
    addToList?: InjectableCss;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: 14px;
        `,
    },
    removeLink: {
        css: css`
            letter-spacing: 1px;
            margin-right: 10px;
            margin-bottom: 0;
            white-space: nowrap;
            background: #000;
            width: 233px;
            padding: 12px 13px;
            color: #fff;
            font-weight: 400;
            font-size: 12px;
            text-transform: uppercase;
            height: 40px;
            ${TypographyStyle} {
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            &:hover {
                ${TypographyStyle} {
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        `,
    },
    addToList: {
        css: css`
            min-width: 235px;
            button {
                min-width: 235px;
            }
        `,
    },
    link: {
        link: {
            css: css`
                display: flex;
                background-color: #978970;
                height: 40px;
                width: 235px;
                &:hover {
                    background-color: #6b5d44 !important;
                }
                ${TypographyStyle} {
                    display: flex;
                    align-items: center;
                    color: #fff !important;
                    font-weight: 400 !important;
                    letter-spacing: 1px;
                    font-size: 12px !important;
                    text-transform: uppercase;
                    > ${TypographyStyle} {
                        display: flex;
                        gap: 10px;
                    }
                }
            `,
        },
    },
    stockingBtn: {
        css: css`
            padding: 8px 20px !important;
            background-color: #978970;
            max-height: 40px;
            height: 40px;
            width: 235px;

            &:hover {
                background-color: #6b5d44 !important;
            }

            ${TypographyStyle} {
                color: #fff !important;
                font-weight: 400 !important;
                letter-spacing: 1px;
                font-size: 12px !important;
                text-transform: uppercase;
                display: flex;
                align-items: center;
            }
            /* span[class^="StyledTypography"] {
               
            } */
        `,
    },
    notifyBtn: {
        css: css`
            padding: 8px 20px !important;
            background-color: #978970;
            max-height: 40px;
            height: 40px;
            width: 235px;
            margin-top: 10px;

            &:hover {
                background-color: #6b5d44 !important;
            }

            ${TypographyStyle} {
                color: #fff !important;
                font-weight: 400 !important;
                letter-spacing: 1px;
                font-size: 12px !important;
                text-transform: uppercase;
                display: flex;
                align-items: center;
            }
            /* span[class^="StyledTypography"] {
               
            } */
        `,
    },
    notifyBtnInStock: {
        css: css`
            padding: 8px 20px !important;
            background-color: #afafaf;
            max-height: 40px;
            height: 40px;
            width: 235px;
            margin-top: 10px;

            ${TypographyStyle} {
                color: #fff !important;
                font-weight: 400 !important;
                letter-spacing: 1px;
                font-size: 12px !important;
                text-transform: uppercase;
                display: flex;
                align-items: center;
            }
            /* span[class^="StyledTypography"] {
               
            } */
        `,
    },
    EyeIcon: {
        size: 16,
        color: "#fff",
        css: css`
            margin-right: 10px;
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({
    product,
    variantSelectionCompleted,
    stockingList,
    wishListData,
    stockingListID,
    loadWishList,
    deleteWishListLine,
    notifiyMeHandler,
    addNotifiyMeHandler,
    session,
    billToNumber,
    productNumbers,
    productInfo,
}) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }
    const { inventory } = productInfo;
    const qtyOnHand = inventory?.qtyOnHand;

    const loadNotifyme = () => {
        if (billToNumber && session.email && !qtyOnHand) {
            notifiyMeHandler({
                billToNumber,
                emailId: session.email,
                productNumbers: [product.productNumber],
            });
        }
    };

    React.useEffect(() => {
        stockingList({});
        loadNotifyme();
    }, []);

    React.useEffect(() => {
        loadWishList({
            wishListId: stockingListID,
            expand: ["getAllLines"],
        });
    }, [stockingListID]);

    const isProductInStock = productNumbers.includes(product.productNumber);

    const [isItemInWishlist, setIsItemInWishlist] = React.useState(false);

    React.useEffect(() => {
        if (product.id && wishListData && wishListData.wishListLineCollection) {
            const filterdWishlist = wishListData.wishListLineCollection.filter(item => item.productId === product.id);
            if (filterdWishlist.length) {
                setIsItemInWishlist(true);
            } else {
                setIsItemInWishlist(false);
            }
        }
    }, [wishListData]);

    const onClickNotifyMe = () => {
        addNotifiyMeHandler({
            productID: product.productNumber,
            onSuccess() {
                loadNotifyme();
            },
        });
    };

    // const removeWislistHandler = () => {
    //     if (stockingListID && product.id) {
    //         if (stockingListID && wishListData && wishListData.wishListLineCollection) {
    //             const wishlistLine = wishListData.wishListLineCollection.filter(item => item.productId === product.id);
    //             if (wishlistLine.length) {
    //                 setIsItemInWishlist(false);
    //                 deleteWishListLine({
    //                     wishListId: stockingListID,
    //                     wishListLineId: wishlistLine[0].id,
    //                     onSuccess() {
    //                         loadWishList({
    //                             wishListId: stockingListID,
    //                             expand: ["getAllLines"],
    //                         });
    //                     },
    //                 });
    //             }
    //         }
    //     }
    // };

    const removeWislistHandler = () => {
        if (stockingListID && product.id) {
            if (stockingListID && wishListData && wishListData.wishListLineCollection) {
                const wishlistLine = wishListData.wishListLineCollection.filter(item => item.productId === product.id);
                if (wishlistLine.length) {
                    setIsItemInWishlist(false); // Optimistic UI update
                    deleteWishListLine({
                        wishListId: stockingListID,
                        wishListLineId: wishlistLine[0].id,
                        onSuccess() {
                            loadWishList({
                                wishListId: stockingListID,
                                expand: ["getAllLines"],
                            });
                        },
                    });
                }
            }
        }
    };

    const IteminWishlist = () => {
        setIsItemInWishlist(true);
    };

    let isAllocatedProduct = null;

    if (product && product.properties.allocated_Product) {
        isAllocatedProduct = product.properties.allocated_Product.toLowerCase();
    }

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                {!isItemInWishlist ? (
                    <StyledWrapper {...styles.addToList}>
                        <ProductAddToListLink
                            data-test-selector="productDetails_addToList"
                            extendedStyles={styles.link}
                            labelOverride="Add to Stocking Items"
                            IteminWishlist={IteminWishlist}
                        />
                    </StyledWrapper>
                ) : (
                    <Link {...styles.removeLink} onClick={() => removeWislistHandler()}>
                        <Icon src={InToWishList} {...styles.EyeIcon} />
                        <Typography>{translate("Remove From Stocking List")}</Typography>
                    </Link>
                )}

                <Link {...styles.stockingBtn} href="/MyAccount/MyLists">
                    <Icon src={Eye} {...styles.EyeIcon} />
                    <Typography>{translate(" View My Stocking List")}</Typography>
                </Link>
            </StyledWrapper>

            {(qtyOnHand ?? 0) < 1 && isAllocatedProduct === "false" && (
                <StyledWrapper>
                    {isProductInStock ? (
                        <Link {...styles.notifyBtnInStock}>
                            <Icon src={Mail} {...styles.EyeIcon} />
                            <Typography>{translate("IN STOCK NOTIFICATION ON")}</Typography>
                        </Link>
                    ) : (
                        <Link {...styles.notifyBtn} onClick={() => onClickNotifyMe()}>
                            <Icon src={Mail} {...styles.EyeIcon} />
                            <Typography>{translate("Notify Me When In Stock")}</Typography>
                        </Link>
                    )}
                </StyledWrapper>
            )}

            {isAllocatedProduct === "true" && (
                <StyledWrapper style={{ marginTop: 10 }}>
                    <ContactAccountMangerButton />
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
